module.exports = __webpack_public_path__ + "media/images/shapes/angles/angle-right-242992e7a58760bffc586b4557f332c7ea54195bb095ea03aaa839c9382ac5e4.svg";